import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const MoreVerticalIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue5d4'}</MuiIcon>
        );
    })
